export const quickAnswer =
  '先查成就触发条件和存档注意事项，再开始关键选择；配装分享链接不代表游戏内成就完成。';

## 本站覆盖哪些成就

当前重点覆盖 The Party Won’t Stop 的卡拉 OK 选择，以及 Combat Readiness 所需的额外战斗能力。详情页分别给出方向答案与通关后进度要求。

## 开始前先检查存档

如果选择错误可能影响当前尝试，先确认是否有早于关键节点的存档。不要假定流程结束后一定能补救。

## 成就没解锁时

检查游戏内任务奖励、能力配置和成就状态。网站[配装工具](/build-planner)没有连接游戏，无法验证成就是否达成。
